/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetFileListResponse } from '../models/GetFileListResponse';
import type { UploadFilesRequest } from '../models/UploadFilesRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MediaService {
    /**
     * Uploads files.
     * Uploads files to media storage.
     * @param folder
     * @param formData
     * @returns void
     * @throws ApiError
     */
    public static uploadFilesEndpoint(
        folder: string,
        formData: UploadFilesRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/media/{folder}',
            path: {
                'folder': folder,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a list of files.
     * Gets a list of files.
     * @param folder Search by the file folder.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @returns GetFileListResponse The file list has been found.
     * @throws ApiError
     */
    public static getFileListEndpoint(
        folder: string,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetFileListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/media/{folder}',
            path: {
                'folder': folder,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
            },
        });
    }
    /**
     * Gets a file.
     * Gets a file with details.
     * @param id File identifier.
     * @returns void
     * @throws ApiError
     */
    public static getFileEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/media/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The file has not been found.`,
            },
        });
    }
    /**
     * Deletes the file.
     * Deletes the file by its id.
     * @param id File identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteFileEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/media/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                404: `The file has not been found.`,
            },
        });
    }
}
